var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Layout',[_c('div',{staticClass:"search-main main"},[_c('section',{staticClass:"recent_course"},[_c('SearchResultItem',{attrs:{"items":_vm.items}})],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }